import { downloadItems } from "@/mocks/homeData";

export default function DownloadZone() {
  return (
    <section id="download" className="px-4 md:px-8 py-12 border-t border-background-200/60 bg-background-100/70">
      <div className="mb-6">
        <p className="text-xs tracking-[0.3em] text-primary-600 font-label mb-2">DOWNLOAD</p>
        <h2 className="font-heading text-xl md:text-3xl font-black text-foreground-950">资源下载与清单导出</h2>
        <p className="mt-2 text-sm text-foreground-600">多端同步收藏与订阅，随时取用本周推荐清单。</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {downloadItems.map((item) => (
          <div
            key={item.name}
            className="group bg-background-50 border border-background-200/80 rounded-lg p-5 flex flex-col"
          >
            <div className="flex items-start justify-between">
              <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${item.icon} text-2xl`} />
              </span>
              {item.tag ? (
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-[11px]">
                  {item.tag}
                </span>
              ) : null}
            </div>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.name}</h3>
            <p className="mt-1 text-xs text-foreground-500">{item.size}</p>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
            <button
              type="button"
              className="mt-5 w-full h-10 rounded-md bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-700 inline-flex items-center justify-center gap-1.5"
            >
              <i className="ri-download-2-line" /> 立即下载
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}